import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ed36eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-name-picker" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue';
import { useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from './transitions';
import { NamedColor } from 'src/types/game.types';
import { useModule } from 'src/modules/modules';
import { titleCase } from 'util/util';
import { sample, shuffle } from 'lodash';
import { hapticsImpactLight } from 'src/util/device-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'name-picker',
  props: {
    names: null,
    targetName: null
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const { names = [], targetName } = __props as {
    names: NamedColor[],
    targetName: NamedColor
}

_useCssVars(_ctx => ({
  "1a948d96": (_unref(theme).theme.cardBg)
}))

const { theme } = useModule();




const handleNameSelected = (name: NamedColor) => {
    hapticsImpactLight()
    emit('select', name, usedHint.value);
}

const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false && index === names.length - 1){
        entered.value = true;
        emit('enter');
    }
}

const notSureLabels = [
    "I'm not sure!",
    "Who would know this?!",
    "Literally Impossible.",
    "Who knows...",
    "Beats me!",
    "No Thanks.",
    "I'll pass.",
    "You tell me!",
    "Too difficult!",
    "Mercy, please!",
]

const namesFiltered = ref(names);
const usedHint = ref(false);
const allowNotSure = ref(names.length === 4 ? sample([true, false])! : false);

const getRandomName = () : NamedColor => {
    let name = sample(namesFiltered.value)!;
    if (name.hex === targetName.hex){
        return getRandomName();
    }
    return name;
}

const handleNarrowOptions = () => {
    usedHint.value = true;
    allowNotSure.value = false;
    namesFiltered.value = shuffle([
        targetName,
        getRandomName(),
    ])
}

expose({
    leave: () => gameSetLeave(useMotions())
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(namesFiltered.value, (n, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("li", _mergeProps({
        key: n.hex,
        class: "k-name-picker-item"
      }, _unref(getGameSetTransitions)(i, { onComplete: handleTransitionComplete })), [
        _createElementVNode("button", {
          class: "k-name-picker-btn",
          onClick: () => handleNameSelected(n)
        }, _toDisplayString(_unref(titleCase)(n.name)), 9, _hoisted_2)
      ], 16)), [
        [_directive_motion, `btnMotion${i}`]
      ])
    }), 128)),
    (allowNotSure.value)
      ? _withDirectives((_openBlock(), _createElementBlock("li", _mergeProps({
          key: 0,
          class: "k-name-picker-item"
        }, _unref(getGameSetTransitions)(__props.names.length, { onComplete: handleTransitionComplete })), [
          _createElementVNode("button", {
            class: "k-name-picker-btn",
            onClick: handleNarrowOptions
          }, _toDisplayString(_unref(sample)(notSureLabels)), 1)
        ], 16)), [
          [_directive_motion, `btnMotion${__props.names.length}`]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})